import React, { useMemo } from 'react';
import { Box } from '@mui/system';
import Template from '@/components/dynamicComponent/Template';
import PageHeader from '@/components/PageHeader';
import { fieldGenerator } from '@/lib/dynamicTable';
import locale from 'antd/es/date-picker/locale/zh_TW';

export default function CommitteeTransfer({ showHeader = true }) {
  const dynamicStructure = useMemo(
    () => ({
      // 管委會移交記錄
      dbName: 'committeeTransfer',
      text: '管委會移交記錄',
      funcs: [{ name: 'createData', text: '新增移交記錄', type: 'EditButton' }],
      fields: {
        // 各欄位的資料型態
        createTime: fieldGenerator('transferDate', '移交時間', 'DatePicker', {
          locale,
        }),
        remark: fieldGenerator(
          'remark',
          '備註',
          'TextArea',
          {},
          {
            rules: [{}],
          },
          {
            width: 400,
          }
        ),
        file: fieldGenerator(
          'file',
          '移交檔案',
          'Upload',
          {
            multiple: true,
            accept: '.pdf,.doc,.docx,.xls,.xlsx',
          },
          {
            rules: [{}],
          }
        ),
      },
      manipulate: [
        { name: 'editData', text: '編輯', type: 'EditButton' },
        { name: 'deleteData', text: '刪除', type: 'DeleteButton' },
      ],
    }),
    []
  );

  return (
    <Box>
      {/* header */}
      {showHeader && (
        <PageHeader
          title="管委會移交記錄"
          breadcrumbs={[{ name: '組織管理' }, { name: '管委會移交記錄' }]}
        />
      )}
      <Template {...{ dynamicStructure }} />
    </Box>
  );
}
